import { loggerService } from '../services/logger/loggerService'
import notNull from '../utils/notNull'

/**
 * Try to cast items and ignore errors
 *
 * @param items
 * @param castFunction
 */
const castListItems = <T, S>(items: Array<T>|{[key: string]: T}, castFunction: (item: T) => S): Array<S> => {
  const newList = (Object.values(items) || [])
    .map(item => {
      try {
        return castFunction(item)
      } catch (error) {
        loggerService.warning(error)
        return null
      }
    })
    .filter(notNull)

    return newList
}

export default castListItems
